import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { EventMessage, PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './auth/authConfig';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { AppContextProvider } from './context/app-context';
import { ConfigProvider } from 'antd';

export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <ConfigProvider
	  theme={{
		token: {
		  colorPrimary: '#2b4570',
 		  colorBgTextHover: '#2b457019',
		  colorBgTextActive: '#2b457030',
		  fontFamily: "'Roboto'",
	    },
	    components: { }
	  }}
	>
	  <BrowserRouter>
		<MsalProvider instance={msalInstance}>
		  <AppContextProvider>
			<App />
		  </AppContextProvider>
		</MsalProvider>
	  </BrowserRouter>
	</ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
